export default __webpack_public_path__ + "static/media/71_photo.aea7be0b.jpg";